import { RootStore } from '@/store/rootStore'
import { Module } from 'vuex'
import { StateEntity } from './types'

const getDefaultStateEntity = () => {
  return {
    updatedValue: false,
    entity: '',
    columns: null,
    url: '',
    fieldMaxLength: null
  }
}

export const entity: Module<StateEntity, RootStore> = {
  namespaced: true,
  state: {
    entity: { ...getDefaultStateEntity() }
  },
  mutations: {
    resetEntity (state) {
      state.entity = { ...getDefaultStateEntity() }
    },
    setEntity (state, { param }) {
      state.entity = { ...param }
    },
    updateEntity (state, { param }) {
      state.entity = { ...state.entity, ...param }
    }
  },
  actions: {
    resetEntity ({ commit }) {
      commit('resetEntity')
    },
    setEntity ({ commit }, param) {
      commit('setEntity', { param })
    },
    updateEntity ({ commit }, param) {
      commit('updateEntity', { param })
    }
  },
  getters: {
    entity (state) {
      return state.entity
    }
  }
}
